import PropTypes from "prop-types";
import { Logos } from "@/config/antd";

const Logo = ({ name, size = "medium", className = "", onClick, alt }) => {
  // Define logo sizes
  const sizes = {
    small: { width: 50 },
    medium: { width: 100 },
    large: { width: 200 },
    xlarge: { width: 300 },
  };

  return (
    <img
      src={Logos[name]}
      alt={alt || `${name} Logo`}
      className={className}
      onClick={onClick}
      style={{
        ...sizes[size],
        cursor: onClick ? "pointer" : "default",
      }}
    />
  );
};

Logo.propTypes = {
  name: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium", "large", "xlarge"]),
  className: PropTypes.string,
  onClick: PropTypes.func,
  alt: PropTypes.string,
};

export default Logo;
